<div [ngClass]="{ 'white' : white === true }" class="main">
  <div class="text">{{text}}</div>
  <div class="arrow">
    <span class="material-symbols-outlined">
      arrow_downward
    </span>
  </div>
</div>
